import {
  ref,
  computed,
} from 'vue';

export function useFloatingPanel() {
  const isVisible = ref(false);
  const isPinned = ref(false);
  const isMinimized = ref(false);
  const contextType = ref(null);
  const contextData = ref(null);
  const activeTab = ref('producto');

  let hideTimeout = null;

  const panelState = computed(() => {
    if (isMinimized.value) return 'minimized';
    if (!isVisible.value) return 'hidden';
    return 'expanded';
  });

  function show(type = null, data = null) {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }

    if (type) contextType.value = type;
    if (data) contextData.value = data;
    isVisible.value = true;
  }

  function hide() {
    if (isPinned.value || isMinimized.value) return;

    hideTimeout = setTimeout(() => {
      isVisible.value = false;
    }, 300);
  }

  function hideNow() {
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      hideTimeout = null;
    }
    isVisible.value = false;
    isPinned.value = false;
    isMinimized.value = false;
  }

  function togglePin() {
    isPinned.value = !isPinned.value;
  }

  function pin() {
    isPinned.value = true;
  }

  function unpin() {
    isPinned.value = false;
  }

  function minimize() {
    isMinimized.value = true;
  }

  function expand() {
    isMinimized.value = false;
  }

  function toggleMinimize() {
    isMinimized.value = !isMinimized.value;
  }

  function updateContext(type, data) {
    contextType.value = type;
    contextData.value = data;
  }

  function setActiveTab(tab) {
    activeTab.value = tab;
  }

  return {
    isVisible,
    isPinned,
    isMinimized,
    contextType,
    contextData,
    activeTab,
    panelState,
    show,
    hide,
    hideNow,
    togglePin,
    pin,
    unpin,
    minimize,
    expand,
    toggleMinimize,
    updateContext,
    setActiveTab,
  };
}
